<template>
  <div v-cloak class="dashboard">

    <img src="" alt="" id="myimage" />
    <threshold-level-one v-if="usage_threshold_level === 1" />
    <threshold-level-two v-if="usage_threshold_level === 2" />

    <!--     Exam Details       -->
    <dashboard-details />

    <dashboard-artificial-lag />
    <dashboard-start-section />

    <!--    Progress     -->
    <div v-if="!is_demo">
        <dashboard-progress />
    </div>

    <!--     Previous attempts     -->
    <div v-if="!is_demo">
      <dashboard-previous-attempts />
    </div>

  </div>
</template>

<script>
import DashboardDetails from './DashboardDetails'
import DashboardProgress from './DashboardProgress'
import DashboardStartSection from './DashboardStartSection'
import DashboardPreviousAttempts from './DashboardPreviousAttempts'
import DashboardArtificialLag from './DashboardArtificialLag'
import ThresholdLevelOne from '../Alerts/ThresholdLevelOneReached'
import ThresholdLevelTwo from '../Alerts/ThresholdLevelTwoReached'
import { mapState } from 'vuex'

export default {
  components: {
    DashboardProgress,
    DashboardDetails,
    DashboardPreviousAttempts,
    DashboardArtificialLag,
    ThresholdLevelOne,
    ThresholdLevelTwo,
    DashboardStartSection
  },
  computed: {
    ...mapState(['is_demo', 'usage_threshold_level'])
  },

  methods: {},

  mounted() {
    // let imageCapture
    // const img = document.getElementById('myimage')
    // window.navigator.mediaDevices
    //   .getUserMedia({ video: true })
    //   .then(function(mediaStream) {
    //     let mediaStreamTrack = mediaStream.getVideoTracks()[0]
    //     imageCapture = new ImageCapture(mediaStreamTrack)
    //     console.log(imageCapture)
    //     imageCapture
    //       .takePhoto()
    //       .then((blob) => {
    //         console.log('blob')
    //         console.log(blob)
    //         let fd = new FormData()
    //         fd.append('image', blob, 'aaaa.jpg')
    //         fd.append('user_id', 11)
    //         fd.append('exam_id', 11)
    //         axios.post('http://localhost:8000/v1/store-image', fd, {
    //           headers: { 'Content-Type': 'multipart/form-data' }
    //         })
    //         let url = window.URL.createObjectURL(blob)
    //         img.src = url
    //       })
    //       .catch((error) => {
    //         console.log(error)
    //       })
    //   })
    //   .catch((error) => {
    //     console.error('error:', error)
    //   })
    // setTimeout(() => {
    //   imageCapture
    //     .takePhoto()
    //     .then((blob) => {
    //       console.log(blob)
    //       axios.post('http://localhost:8000/v1/store-image', {
    //         user_id: 12,
    //         exam_id: 12,
    //         image: blob
    //       })
    //       let url = window.URL.createObjectURL(blob)
    //       img.src = url
    //     })
    //     .catch((error) => {
    //       console.log(error)
    //     })
    // }, 10000)
  }
}
</script>
